import Dashboard from '@/views/Dashboard/index.vue'

import Characters from '@/views/Dashboard/Characters.vue'
import CharacterUpdate  from '@/views/Dashboard/CharacterUpdate.vue'
import WebBank from '@/views/Dashboard/WebBank.vue'
import Vip from '@/views/Dashboard/Vip.vue'
import Activity from '@/views/Dashboard/Activity.vue'

const routes = [
  {
    path: '/cuenta',
    component: Dashboard,
    children: [
      {
        name:'dashboard',
        path:'',
        component:Characters
      },
      {
        path: 'personajes',
        name:'dashboard_characters',
        component: Characters,
      },
      {
        name:'characters_update',
        path: 'personajes/:update',
        component: CharacterUpdate
      },
      {
        name:'dashboard_vip',
        path: 'vip',
        component: Vip
      },
      {
        name:'dashboard_bank',
        path: 'banco',
        component: WebBank
      },
      {
        name:'dashboard_activity',
        path: 'actividad',
        component: Activity
      },
    ],
    meta: {
      title: 'Panel de Control ༒ MUCRISIS',
      layout: 'default',
      requiresAuth: true,
      metaTags: [
        {
          name: 'description',
          content: 'Panel de control de usuario, personajes y mucho más.'
        }
      ]
    }
  },
 
]

export default routes